"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInbtWithdrawSchema = void 0;
const yup = __importStar(require("yup"));
const helpers_1 = require("@/helpers");
const createInbtWithdrawSchema = ({ translationKeys, limits, tradingAccountCurrencyCode, propsToReplacePara1, initialValue }) => {
    var _a, _b;
    const min = Number((limits === null || limits === void 0 ? void 0 : limits.limits) && ((_a = limits === null || limits === void 0 ? void 0 : limits.limits[tradingAccountCurrencyCode]) === null || _a === void 0 ? void 0 : _a.min));
    const max = Number((limits === null || limits === void 0 ? void 0 : limits.limits) && ((_b = limits === null || limits === void 0 ? void 0 : limits.limits[tradingAccountCurrencyCode]) === null || _b === void 0 ? void 0 : _b.max));
    return yup.object().shape({
        countryCode: yup.string()
            .required(translationKeys.validationWithdrawCountryCodeRequired),
        currencyCode: yup.string()
            .required(translationKeys.validationWithdrawCountryCodeRequired),
        beneficiaryName: yup.string()
            .required(translationKeys.validationWithdrawBeneficiaryNameRequired),
        beneficiaryAddress: yup.string()
            .required(translationKeys.validationWithdrawBeneficiaryAddressRequired),
        ibanAccountNumber: yup.string()
            .typeError(translationKeys.validationAccountNumberNumeric)
            .required(translationKeys.validationWithdrawIbanAccountNumberRequired),
        branchCode: yup.string()
            .required(translationKeys.validationWithdrawBranchCodeRequired),
        swiftCode: yup.string()
            .required(translationKeys.validationWithdrawSwiftCodeRequired),
        beneficiaryBankName: yup.string()
            .required(translationKeys.validationWithdrawBeneficiaryBankNameRequired),
        beneficiaryBankAddress: yup.string()
            .required(translationKeys.validationWithdrawBeneficiaryBankAddressRequired),
        accountNickname: yup.string(),
        amount: yup.number()
            .transform((currentValue, originalValue) => Number((0, helpers_1.removeThousandSeparator)(originalValue)))
            .required(translationKeys.validationWithdrawAmountRequired)
            .typeError(translationKeys === null || translationKeys === void 0 ? void 0 : translationKeys.request_amount_invalid_type)
            .minMaxLimit(min, max, (0, helpers_1.withDynamicTranslation)(translationKeys === null || translationKeys === void 0 ? void 0 : translationKeys.validationWithdrawAmountMax, propsToReplacePara1), initialValue),
        acknowledgement: yup.bool()
    });
};
exports.createInbtWithdrawSchema = createInbtWithdrawSchema;
